export default __webpack_public_path__ + "static/media/0108.bd90681f.png";